import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { CarouselLayout, CarouselType } from '../../../common';
import { CarouselItemImpressionEventInfo, CarouselItemSelectEventInfo } from '../../interfaces/carousel-item-select-gtm.interface';
import { ImgQuery } from '../../services';
import { Screen, ScreenService } from '../../services/screen.service';
import { CarouselViewModel } from '../carousel/carousel.view-model';
import { SeasonCollectionCarouselViewModel } from './season-collection-carousel.view-model';

@Component({
  selector: 'osn-shared-season-collection-carousel',
  templateUrl: './season-collection-carousel.component.html',
  styleUrls: ['./season-collection-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeasonCollectionCarouselComponent implements OnInit {
  @Input() public showSeoTitle = false;
  @Output() public carouselItemSelect: EventEmitter<CarouselItemSelectEventInfo> = new EventEmitter();
  @Output() public carouselItemImpression = new EventEmitter<CarouselItemImpressionEventInfo>();

  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private _vm: SeasonCollectionCarouselViewModel;
  public carouselViewModel: CarouselViewModel;
  public imgQuery: ImgQuery;

  get isLandscapeLayout(): boolean {
    return this.vm.layout === CarouselLayout.LandscapeSmall || this.vm.layout === CarouselLayout.LandscapeLarge;
  }

  @Input() public set vm(vm: SeasonCollectionCarouselViewModel) {
    this._vm = vm;
    this.carouselViewModel = {
      items: vm.items,
      layout: vm.layout,
      type: CarouselType.SeasonCollectionCarousel,
      resolved: vm.resolved,
    };
  }

  public get vm() {
    return this._vm;
  }

  public get routerLink(): string {
    return this.vm.routerLink;
  }

  public get visible(): boolean {
    return !!this.vm && (!this.vm.resolved || (this.vm.resolved && this.vm.items && this.vm.items.length > 0));
  }

  @HostBinding('class.carousel-container')
  public get carouselContainerClass() {
    return this.visible;
  }

  constructor(private readonly screenService: ScreenService) {}

  public ngOnInit() {
    this.imgQuery = {
      XS: { url: this.getPlatformImageUrl(Screen.XS) },
      SM: { url: this.getPlatformImageUrl(Screen.SM) },
      MD: { url: this.getPlatformImageUrl(Screen.MD) },
      LG: { url: this.getPlatformImageUrl(Screen.LG) },
      XL: { url: this.getPlatformImageUrl(Screen.XL) },
    };
  }

  private getPlatformImageUrl(screen: Screen): string {
    const fallbackImage = this.vm.backgroundImageUrl;
    const background = this.vm.backgroundImageUrlsByPlatform?.find(
      (platformGroup) => platformGroup.platform === this.screenService.mapScreenToPlatformType(screen)
    );

    return background?.imageUrl || fallbackImage;
  }

  public onCarouselItemImpression(contentInfo: { guid: string; index: number; carouselTitle: string; carouselItemType: string }): void {
    this.carouselItemImpression.emit({
      guid: contentInfo.guid,
      index: contentInfo.index,
      carouselTitle: this._vm.localizedTitles.en,
      carouselItemType: contentInfo.carouselItemType,
    });
  }

  public onCarouselItemSelect({ carouselItemDetails, carouselTitle }): void {
    this.carouselItemSelect.emit({ guid: carouselItemDetails.id, carouselTitle, carouselItemType: carouselItemDetails.category });
  }
}
